{
  "fileTypeNotSupported": "File type not supported",
  "fileSizeExceeded": "File Size Exceeded Maximum Allowed Size Of 2MB",
  "searchByModel": "Search by model",
  "mileageFrom": "From",
  "mileageTo": "To",
  "add": "add",
  "change": "change",
  "delete": "delete",
  "language": "language",
  "hello": "hello",
  "registration": "Registration",
  "forgetPassword": "Forgot your password?",
  "mailText": "or login via",
  "placeholderEmail": "Enter your email",
  "placeholderPassword": "Enter password",
  "placeholderLogin": "Enter login",
  "enter": "Enter",
  "bestOffer": "Best offers",
  "closestEvents": "Closest events",
  "additionalInfo": "Additional Information",
  "businessDifference": "How is your business different from others? What are the benefits?",
  "placeholderDescribe": "Describe",
  "businessIssues": "What are the problems in your company ?",
  "businessPerspectives": "What is the outlook for your business ?",
  "businessReasons": "Reason for selling your business",
  "businessTrainingAdvice": "Business training and advice",
  "businessSupport": "Will his new owner be able to count on your help and support ?",
  "location": "Location",
  "city": "City",
  "address": "Address",
  "pointBtn": "Specify a point on the map",
  "example": "Example",
  "contactInfo": "Contact information",
  "name": "Name",
  "placeholderName": "Enter your name",
  "placeholderContacts": "Contact number",
  "description": "Description",
  "title": "Title",
  "tags": "Tags",
  "placeholderAddTag": "Add tags",
  "settingCost": "Setting the cost",
  "placeholderPriceFrom": "Price, from",
  "placeholderPriceBefore": "Price, up to",
  "placeholderPeriodPrice": "Payment period",
  "categoryTitle": "Category",
  "paymentTitle": "Setting up payment",
  "placeholderSetPriceDollars": "indicate the price in dollars",
  "photo": "Photo",
  "estateTitle": "Detailed information about the estate",
  "estateType": "Estate type",
  "placeholderChoose": "Choose",
  "roomAmount": "Number of rooms",
  "amenitiesTitle": "Amenities",
  "nearTitle": "Nearby is",
  "area": "Area (sqft)",
  "bathroom": "Bathrooms",
  "workScheduleTitle": "Schedule",
  "additionalTitle": "Additional requirements",
  "experienceTitle": "Experience",
  "placeholderPoint": "Specify",
  "englishLevel": "English level",
  "workPermit": "Work permit",
  "workPeriod": "Work period",
  "documents": "Documents",
  "currencyTitle": "Exchange rates",
  "aboutUs": "About us",
  "contacts": "Contacts",
  "blog": "Blog",
  "map": "Site map",
  "forBusiness": "For business",
  "paidServices": "Paid services",
  "companyDetails": "Company details",
  "support": "Support",
  "privacyAgreement": "Privacy agreement",
  "termsOfUse": "Terms of use",
  "helpAndFeedback": "Help and Feedback",
  "enterAndRegister": "Login/Registration",
  "applyAds": "Post an ads",
  "login": "Login",
  "toFavorites": "To favorites",
  "share": "Share",
  "adsAuthor": "Ads author",
  "adsAllAuthor": "All author's ads",
  "showPhone": "Show contacts",
  "telegram": "Telegram",
  "biziCommunities": "BIZI communities on social networks:",
  "preFooterText": "All online advertisements in the USA on BIZI - here you will find what you were looking for! By clicking on the 'Post an ads' button, you can place an ad on any topic easily and quickly. Using the BIZI service, you can buy or sell almost anything from hand to hand.",
  "chicago": "Chicago",
  "call": "Call",
  "twoDaysAgo": "2 days ago",
  "email": "Email",
  "myPhones": "Phone number",
  "phone": "Phone",
  "personalData": "Personal data",
  "changePassword": "Change password",
  "save": "Save",
  "surname": "Surname",
  "middleName": "Middle Name",
  "oldPassword": "old password",
  "newPassword": "new password",
  "confirmNewPassword": "confirm the new password",
  "allCategories": "All Categories",
  "noAds": "No active ads",
  "createAdsText": "Submit an ads and make a profitable deal!",
  "createAds": "Create Ads",
  "increaseSaleText": "Use it to increase the sale of services or goods",
  "aboutAuto": "About the vehicle",
  "vehicleBrand": "Vehicle brand",
  "vehicleModel": "Vehicle Model",
  "carMake": "Make",
  "mileAge": "Mileage",
  "price": "Price",
  "saveInDraft": "Save in draft",
  "publish": "Publish",
  "recommendationsForYou": "Recommendations for you",
  "services": "Services",
  "filters": "Filters",
  "businessIn": "Business in",
  "changeBtn": "Change",
  "addTags": "Add tags",
  "negotiable": "Negotiable",
  "fixed": "Fixed",
  "search": "Search",
  "firstPhotoOnBanner": "The first photo will be on the cover of the ads. Photo must be in .jpg format",
  "makeMainBtn": "Make main",
  "mainPhoto": "Main photo",
  "photoDownloaded": "Photo downloaded",
  "needUniqueDesignAds": "Unique ads design",
  "wantPublicationAds": "Place an ads on the main page",
  "wantPublicationUpAds": "Place an ads at the top of the feed",
  "placeholderMacExample": "For example, Macbook 16 pro",
  "enter16Symbols": "Enter at least 16 characters",
  "enter40Symbols": "Enter at least 40 characters",
  "yearOfIssue": "Year of issue",
  "addPhoto": "Add photo",
  "forExample2Years": "For example two years",
  "linkToWebsite": "Link to website",
  "placeholderEnterLink": "Insert link",
  "aboutBusiness": "About business",
  "whenBusinessWasCreated": "How many years has your business been",
  "numberOfCustomers": "Number of customers",
  "modelYear": "Model year",
  "specifications": "Specifications",
  "mileage": "Mileage",
  "carType": "Car type",
  "carModel": "Model",
  "seeAll": "See all",
  "used_car": "used car",
  "new_car": "new car",
  "certified_pre_owned": "certified pre owned",
  "with_experience": "with experience",
  "without_experience": "without experience",
  "moreDetailed": "More detailed",
  "fluent": "fluent",
  "yes": "yes",
  "required": "required",
  "workingPermit": "Working permit",
  "availabilityOfDocuments": "Availability of document",
  "availabilityOfSsn": "Availability of SSN",
  "availabilityOfDl": "Driver license",
  "driverLicenseUSA": "Driver's license (USA)",
  "paymentSetup": "Payment Setup",
  "paymentPerHour": "Payment per hour",
  "paymentRangePerHour": "Payment range per hour",
  "salaryPerMonth": "Salary per month",
  "salaryRangePerMonth": "Salary range per month",
  "salaryRangePerHourByMonth": "Salary range per hour by month",
  "businessInformation": "Business information",
  "businessInfoLifespan": "How long business exist",
  "profile": {
    "changePassword": "Change password",
    "messangers": "Messengers",
    "socialMedia": "Social media",
    "ads": "Ads",
    "fav": "Favorites",
    "archive": "Ads archive",
    "settings": "Settings",
    "support": "Support",
    "logout": "Logout",
    "active": "Active",
    "mod": "Moderation",
    "inactive": "Planned",
    "rejected": "Rejected",
    "draft": "Draft",
    "profile": "Profile"
  },
  "notify": {
    "success": "Success",
    "add": "Ads added",
    "delete": "Ads deleted"
  },
  "work": "Work",
  "paymentPeriod": "Payment period",
  "profitRangePer": "Profit range per",
  "profitPer": "Profit per",
  "businessTurnover": "Approximate profit and turnover",
  "businessProblems": "What problems does your company have?",
  "businessProspects": "What are prospects for your business?",
  "businessSaleReasons": "The reason for the sale of the business?",
  "futureBusinessSupport": "Assistance in further development",
  "More_then_1000": "> 1000",
  "Less_then_1000": "< 1000",
  "More_then_10000": "> 10000",
  "Year": "year",
  "Month": "month",
  "today": "today",
  "dayAgo": "day ago",
  "daysAgoRuVar": "days ago",
  "daysAgoEnVar": "days ago",
  "state": "State",
  "exampleAdsAddress": "For example, 1122 W Randolph St, Chicago, IL 60607",
  "telEmail": "Telephone and Email",
  "socialMedia": "Social media",
  "experience": "Experience",
  "foundInCategories": "Found in categories",
  "searchBtn": "Search",
  "auth": {
    "authError": "Wrong email/phone number or password",
    "authEmailError": "Please enter a valid email address",
    "authPasswordError": "The password must contain at least 8 characters, uppercase and lowercase letters",
    "enterMail": "Email",
    "password": "Password",
    "name": "Your name",
    "phone": "Your phone",
    "emailInUse": "This email is already in use",
    "invalidPhoneNumberFormat": "Invalid phone number format"
  },
  "fieldIsRequired": "Field is required",
  "requiredFields": "Required fields",
  "networkError": "Network error",
  "adsCreated": "Ads successfully created",
  "basic": "basic",
  "Less_then_year": "Less then year",
  "More_then_year": "More then year",
  "Years": "Years",
  "chooseCategory": "Choose category",
  "createBtn": "Create",
  "reset": "Reset",
  "full_time": "Full time",
  "part_time": "Part time",
  "estate": "Estate",
  "auto": "Vehicle sales",
  "business": "Business sales",
  "recommendedTags": "Recommended tags",
  "selectedTags": "Selected tags",
  "noTags": "No tags",
  "notFound": "not found",
  "show": "Show",
  "resetFiltration": "Reset filters",
  "negotiatedPrice": "Negotiated price",
  "vehicleType": "Vehicle type",
  "placeholderChooseModel": "Model",
  "setUpHourPayment": "Enter hourly rate",
  "rangePerHour": "Range per hour",
  "fromRangePayment": "From",
  "toRangePayment": "To",
  "rangePerMonth": "Range of salary per month",
  "setUpPayment": "Enter your salary",
  "paymentPerMonth": "Payment per month",
  "turnOnPrice": "Turn on the price",
  "photoMaximum": "Exceeded the maximum limit of 8 files",
  "buySell": "Buy / Sell",
  "copied": "Copied!",
  "cost": "Cost",
  "disabled": "Disabled",
  "published": "Published",
  "editBtn": "Edit",
  "archiveBtn": "In archive",
  "deleteBtn": "Delete",
  "restoreBtn": "Restore",
  "deleteItems": "Are you sure you want to Delete this record?",
  "toArchivedItems": "Do you really want to Diactivate this ads?",
  "toActivateItems": "Do you really want to Activate this ads?",
  "cancel": "Cancel",
  "useNumber": "Use phone number",
  "useEmail": "Use email",
  "sendToModeration": "Send to Moderation",
  "adsUpdated": "Ads updated",
  "noFavTitle": "Favorites list is empty",
  "noFavBody": "There aren't any added favorites",
  "favAddBtn": "Add",
  "addedToFav": "Added to favorites",
  "removedFromFav": "Removed from favorites",
  "categoryTypeReason": "Category type does not comply with the rules",
  "bannerImageReason": "Banner image does not comply with the rules",
  "subCategoryTypeReason": "Subcategory type does not comply with the rules",
  "startDateReason": "Start date does not comply with the rules",
  "completionDateReason": "Completion date does not comply with the rules",
  "headerReason": "Header does not comply with the rules",
  "descriptionReason": "Description does not comply with the rules",
  "workScheduleReason": "Work schedule does not comply with the rules",
  "additionalRequirementsReason": "Additional requirements do not comply with the rules",
  "paymentPerHourReason": "Payment per hour does not comply with the rules",
  "paymentPeriodReason": "Payment period does not comply with the rules",
  "paymentRangePerHourReason": "Payment range per hour does not comply with the rules",
  "salaryPerMonthReason": "Salary per month does not comply with the rules",
  "salaryRangePerHourByMonthReason": "Salary range per hour by month does not comply with the rules",
  "salaryRangePerMonthReason": "Salary range per month does not comply with the rules",
  "phoneAndEmailReason": "Phone and email does not comply with the rules",
  "socialMediaReason": "Social media does not comply with the rules",
  "messengersReason": "Messengers do not comply with the rules",
  "imagesReason": "Images do not comply with the rules",
  "addressReason": "Address does not comply with the rules",
  "tagsReason": "Tags do not comply with the rules",
  "makeVehicleReason": "Make vehicle does not comply with the rules",
  "modelYearReason": "Model year does not comply with the rules",
  "mileageReason": "Mileage does not comply with the rules",
  "costReason": "Cost does not comply with the rules",
  "negotiatedPriceReason": "Negotiated price does not comply with the rules",
  "profitPerReason": "Profit per does not comply with the rules",
  "profitRangePerReason": "Profit range per does not comply with the rules",
  "advantagesReason": "Advantages do not comply with the rules",
  "problemsReason": "Problems do not comply with the rules",
  "prospectsForBusinessReason": "Prospects for business do not comply with the rules",
  "saleBusinessReason": "Sale business does not comply with the rules",
  "typeOfEstateReason": "Type of estate does not comply with the rules",
  "roomsReason": "Rooms do not comply with the rules",
  "amenitiesReason": "Amenities do not comply with the rules",
  "nearbyReason": "Nearby does not comply with the rules",
  "costFromReason": "Cost from does not comply with the rules",
  "costToReason": "Cost to does not comply with the rules",
  "expirenceReason": "Experience does not comply with the rules",
  "numberOfCustomerReason": "Number of customers does not comply with the rules",
  "vehicleTypeReason": "Vehicle type does not comply with the rules",
  "salaryRangePerHourReason": "Salary range per hour does not comply with the rules",
  "reason": "Reason",
  "subChapter": "Subchapter",
  "specifyTheNumberOfCustomers": "Specify the number of customers",
  "chooseFromTheList": "Choose from the list",
  "enterANumber": "Enter a number",
  "loginViaGoogle": "Login via Google",
  "minimumLength16": "Minimum length is 19 characters",
  "weOnSocials": "We in social media",
  "successRegistration": "Registration complete",
  "russian": "Русский",
  "english": "English",
  "biziBusiness": "Business on BIZI",
  "marketingBizi": "Advertising on the site",
  "privacyPolicy": "Privacy policy",
  "hideContacts": "Hide contacts",
  "quantity": "Quantity ",
  "showMore": "Show more",
  "fio": "Full name",
  "authorContacts": "Author's contacts",
  "authorSocials": "Author's social media",
  "textTo": "Text to",
  "costType": "Cost type",
  "saveAsDraft": "Save as draft",
  "continue": "Continue",
  "or": "Or",
  "any": "Any",
  "numberOfRooms": "Number of rooms",
  "payment": "Payment",
  "to": "To",
  "from": "From",
  "profit": "Profit",
  "profitFor": "Profit for",
  "invalidEmail": "Invalid email format",
  "main": "Main",
  "notifications": "Notifications",
  "maxLength150": "Maximum character count 150",
  "upAds": "Up ads",
  "mustBeGreater": "Must be greater than previous field",
  "no": "No",
  "availabilityOfUSALicense": "Availability of license (USA)",
  "addToArchive": "Add to archive",
  "emptySearchResult": "No results found",
  "totalSearchResults": "results",
  "home": "Home",
  "saveInDraftMobile": "In draft",
  "adsTags": "Tags",
  "theme": "Theme",
  "createDate": "Create date",
  "status": "Status",
  "new": "New",
  "waiting_manager": "Waiting manager",
  "waiting_client": "Waiting client",
  "on_consultation": "On consultation",
  "closed": "Closed",
  "apply": "Apply",
  "supportService": "Support service",
  "applicationSearch": "Application search",
  "allStatus": "All status",
  "addThemeTitle": "Enter theme name",
  "message": "Please, write message",
  "claimCreated": "Claim created",
  "closeRequest": "Close request",
  "hours": "hours",
  "hour": "hour",
  "minute": "minute",
  "minutes": "minutes",
  "ago": "ago",
  "send": "Send",
  "searchCity": "Search",
  "chooseCity": "Choose city",
  "chooseState": "Choose state",
  "clearStateSelection": "Clear State Selection",
  "usa": "USA",
  "shareThrough": "Share through",
  "copyLink": "Or copy link",
  "messageSend": "Message send",
  "noActiveChats": "No active chats.",
  "writeChat": "Write application",
  "didntChoose": "You haven't chosen anything yet",
  "searchByBrand": "Search by brand...",
  "searchByCity": "Search by city...",
  "searchByState": "Search by state...",
  "enterToSellAll": "Press enter to see all results",
  "onlyPhotosLabel": "Only with photos",
  "yourTags": "Your tags",
  "selectTagLabel": "Select tags",
  "selectCityLabel": "Select city",
  "km": "km",
  "mi": "miles",
  "sendToModerationText": "Your ad has been submitted for review. It will be published shortly.",
  "ok": "Ok",
  "1 Bathroom": "1 bathroom",
  "2 Bathrooms": "2 bathrooms",
  "3 Bathrooms": "3 bathrooms",
  "4+ Bathrooms": "4+ bathrooms",
  "sqft": "sqft",
  "baths": "baths",
  "reset-password": {
    "title": "Reset Password",
    "instruction": "Enter your email to receive a reset link",
    "emailLabel": "Email",
    "emailPlaceholder": "Enter your email",
    "newPasswordLabel": "New Password",
    "newPasswordPlaceholder": "Enter new password",
    "submit": "Send Reset Link",
    "updatePassword": "Update Password",
    "loading": "Loading...",
    "successMessage": "Reset link sent to your email",
    "passwordUpdatedMessage": "Password successfully updated",
    "errorMessage": "An error occurred. Please try again",
    "backToLogin": "Back to Login"
  },
  "faq": {
    "title": "Frequently Asked Questions (FAQ)",
    "questions": {
      "1": {
        "question": "What is Bizi?",
        "answer": "Bizi is an online marketplace where you can buy, sell, and discover a wide range of products and services. It’s designed to connect people and businesses in a convenient and trusted environment."
      },
      "2": {
        "question": "Who is Bizi for?",
        "answer": "Bizi is for everyone, especially individuals and businesses from diverse communities. It’s a platform for anyone looking to buy, sell, or connect in their local area."
      },
      "3": {
        "question": "How do I sign up?",
        "answer": "Signing up is easy:\nClick the “Sign Up” button on the website or app.\nEnter your email or phone number and create a password.\nVerify your account, and you’re ready to go!"
      },
      "4": {
        "question": "How do I list an item for sale?",
        "answer": "To list an item:\n1. Log in to your account.\n2. Click “Post an Item.”\n3. Add photos, a title, description, price, and category.\n4. Publish your listing and start connecting with potential buyers."
      },
      "5": {
        "question": "Is using Bizi free?",
        "answer": "Yes! It’s free to sign up, browse, and post items for sale. Optional premium features may be available to enhance the visibility of your listings."
      },
      "6": {
        "question": "How do I communicate with buyers or sellers?",
        "answer": "You can use Bizi’s built-in messaging feature to chat directly with buyers or sellers. Simply click on the item and start a conversation."
      },
      "7": {
        "question": "What kinds of items can I sell on Bizi?",
        "answer": "You can sell most items, including furniture, electronics, clothing, vehicles, and more. However, prohibited items such as illegal goods, weapons, or counterfeit products are not allowed."
      },
      "8": {
        "question": "How can I stay safe while using Bizi?",
        "answer": "For secure transactions:\nMeet in safe, public locations, such as a café or police station.\nAvoid sharing personal or financial details.\nUse cash or verified payment methods for transactions."
      },
      "9": {
        "question": "Can I edit or remove my listings?",
        "answer": "Yes, you can edit or delete your listings anytime. Simply go to your profile, select the item, and choose “Edit” or “Delete.”"
      },
      "10": {
        "question": "How do I report an issue or suspicious activity?",
        "answer": "If you encounter a problem, click the “Report” button on the listing or user profile. Our team will investigate and take appropriate action."
      },
      "11": {
        "question": "Are there any premium features?",
        "answer": "Yes, Bizi offers premium options to boost your listing’s visibility and reach more buyers. Details about pricing and features can be found in your account settings."
      },
      "12": {
        "question": "What if I need help?",
        "answer": "Our support team is here to assist you! Contact us through the “Help” section on the website or app, and we’ll get back to you promptly."
      }
    }
  },
 "marketing": {
    "marketingServices": "Marketing Services",
    "description": "Boost your business with Bizi Inc.’s paid marketing services!\n We offer premium features to help you reach a broader audience and increase your visibility.",
    "bannerAds": "Banner Ads",
    "bannerDescription": "Advertise your business directly on our homepage with custom banner placements!\n Your banner will be prominently displayed to thousands of visitors, giving you the chance to promote products, services, or special offers to a targeted audience.",
    "benefitsTitle": "Benefits of Banner Ads:",
    "benefits": [
      "Increase your brand visibility",
      "Reach a large, engaged audience",
      "Customize your message to attract potential customers"
    ],
    "pricingDetails": "Pricing & Details:",
    "pricingDescription": "For more information on banner placements and pricing, please contact us at {email}.\n Our team will help you create an effective marketing strategy tailored to your business.",
    "callToAction": "Take advantage of these opportunities to grow your business and reach more customers with Bizi Inc.!"
  },
  "about-us": {
    "aboutUs": "About Us",
    "welcome": "Welcome to Bizi Inc. — an online marketplace that connects people, businesses, and opportunities. We have created a platform that is simple and convenient for shopping, selling, and discovering new products and services.",
    "goal": "Our goal is to create a safe and convenient environment for everyone looking for great deals, unique products, or seeking to promote their offers. We work with individuals and businesses from diverse communities, providing opportunities for everyone.",
    "joinUs": "Join Bizi Inc. and explore our growing market that brings people and opportunities together!"
  },
  "for-business": {
    "page": {
      "title": "For Business",
      "intro": "We offer businesses unique opportunities for growth and increased visibility through premium services that will help you attract more customers and stand out from competitors.",
      "whyChoose": {
        "title": "Why Choose Bizi?",
        "visibility": "Maximum Visibility: Showcase your products and services in the most prominent spots on our platform.",
        "professional": "Professional Approach: We provide tailored advertising solutions that align with your business goals.",
        "promotion": "Effective Promotion: Attract more customers using our marketing tools such as banners and paid advertisements."
      },
      "contact": "Contact us at {email} for details about our premium services and pricing. We will help you promote your business and reach new heights!"
    }
  },
  "helpFeedback": {
    "title": "Help & Feedback",
    "intro": "At Bizi Inc., we value your experience and are always here to assist you. If you have any questions, need support, or want to share feedback to help us improve, please don’t hesitate to reach out!",
    "help": {
      "title": "How to Get Help",
      "faqs": "FAQs: Start by visiting our Frequently Asked Questions page to find answers to common questions.",
      "support": {
        "call": "Call us at",
        "phone": "718-662-9695",
        "email": "Email us at",
        "liveChat": "Live Chat: Use the chat feature on our website to connect with a support representative in real-time."
      }
    },
    "feedback": {
      "title": "Share Your Feedback",
      "intro": "Your feedback helps us improve and create a better experience for you.",
      "form": "Use the Feedback Form available on our website to share your thoughts.",
      "email": "Email suggestions directly to"
    },
    "report": {
      "title": "Report Issues",
      "intro": "If you encounter any suspicious listings, users, or technical issues, please report them:",
      "button": "Use the “Report” button on the platform.",
      "email": "Contact us directly with details via email at"
    },
    "closing": "We’re committed to ensuring your experience on Bizi is smooth, secure, and rewarding. Thank you for being part of our growing community!"
  },
  "companyDetailsPage": {
    "title": "Company Details",
    "name": {
      "title": "Name",
      "value": "Bizi Inc."
    },
    "businessType": {
      "title": "Business Type",
      "value": "Online Marketplace Platform"
    },
    "mission": {
      "title": "Mission",
      "value": "To connect individuals and businesses through a seamless, trusted, and user-friendly platform for buying, selling, and discovering products and services."
    },
    "whatWeDo": {
      "title": "What We Do",
      "value": "Bizi Inc. is designed to serve diverse communities by simplifying local transactions and helping users find great deals, unique items, or showcase their offerings. Whether you’re a buyer or seller, Bizi makes connecting easy and efficient."
    },
    "coreValues": {
      "title": "Core Values",
      "trust": "Trust: A safe and secure platform for transactions.",
      "convenience": "Convenience: Intuitive tools that make buying and selling simple.",
      "community": "Community: Connecting people and businesses to create new opportunities."
    },
    "contactInfo": {
      "title": "Contact Information",
      "location": "Location: 1699 Wall Street, Suite 108, Mount Prospect, IL 60056",
      "phone": "Phone: 718-662-9695",
      "website": "https://bizi.one"
    },
    "website": "website"
  },
  "privacyPolicyPage": {
      "metaTitle": "Privacy Policy",
      "title": "Privacy Policy for BIZI",
      "lastUpdated": "Last Updated: {date}",
      "sections": {
        "1" : {
          "title": "1. Information We Collect",
          "points": {
            "1": "Personal Information: Name, email address, phone number, and payment information.",
            "2": "Usage Data: Information about your interactions with our platform, including IP address, browser type, and pages visited."
          }
        },
        "2": {
          "title": "2. How We Use Your Information",
          "points": {
            "1":"To provide and maintain our services.",
            "2":"To process your transactions and manage your account.",
            "3":"To communicate with you, including responding to inquiries and sending updates.",
            "4":"To improve our services based on user feedback and usage data."
          }
        },
        "3": {
          "title": "3. User Rights",
          "points": {
            "1": "Access: Request a copy of the information we hold about you.",
            "2": "Correction: Request corrections to any inaccurate or incomplete information.",
            "3": "Deletion: Request the deletion of your personal information, subject to legal obligations.",
            "4": "Opt-out: Opt-out of receiving marketing communications at any time."
          }
        },
        "4": {
          "title": "4. Data Security",
          "points": {
            "1": "We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, loss, or misuse.",
            "2": "However, no method of transmission over the internet or electronic storage is 100% secure."
          }
        },
        "5": {
          "title": "5. Cookies and Tracking Technologies",
          "points": {
            "1": "We use cookies and similar tracking technologies to enhance your experience on our platform.",
            "2": "You can manage your cookie preferences through your browser settings."
        }
        },
        "6": {
          "title": "6. Sharing Your Information",
          "points": {
            "1": "Service Providers: We may employ third-party companies to facilitate our services, such as payment processing or data analysis.",
            "2": "Legal Requirements: We may disclose your information if required by law or to protect our rights and those of others."
          }
        },
        "7": {
          "title": "7. Third-Party Links",
          "points": {
            "1": "Our services may contain links to third-party websites.",
            "2": "We are not responsible for the privacy practices of these websites.",
            "3": "We encourage you to review the privacy policies of any third-party sites you visit."
          }
        },
        "8": {
          "title": "8. Changes to This Privacy Policy",
          "points": {
            "1": "We may update our Privacy Policy from time to time.",
            "2": "We will notify you of any changes by posting the new Privacy Policy on this page and updating the “Last Updated” date.",
            "3": "We encourage you to review this policy periodically for any changes."
          }
        },
        "9": {
          "title": "9. Contact Us",
          "points": {
            "1": "If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:"
          }
        }
      },
      "contactTitle": "BIZI",
      "contactEmail": "Email: {email}",
      "contactAddress": "Address: {address}"
    },
    "termsOfUsePage": {
      "title": "BIZI Terms of Use",
      "sections": {
        "1": {
          "title": "1. Acceptance of Terms",
          "content": "Welcome to BIZI. By accessing or using our platform, you agree to comply with these Terms of Use. If you do not accept these terms, please refrain from using our services. Your adherence to these terms is essential for a secure and enjoyable experience on our platform."
        },
        "2": {
          "title": "2. User Eligibility",
          "content": "To create an account or use our platform, you must be at least 18 years old. By using BIZI, you affirm that you meet these eligibility requirements and that all information you provide during registration is accurate and truthful."
        },
        "3": {
          "title": "3. Account Registration and Security",
          "content": "You are responsible for maintaining the confidentiality of your account credentials. Any activity performed under your account is your responsibility. We recommend using strong passwords and ensuring your account information remains secure."
        },
        "4": {
          "title": "4. User Conduct and Responsibilities",
          "content": "As a valued member of our community, we expect you to:• Provide honest, accurate details in your listings and transactions.• Act in accordance with all applicable laws and regulations.• Avoid engaging in fraudulent activities or posting misleading content.• Refrain from listing or selling prohibited items (see Prohibited Content and Activities for more information).Your cooperation is essential in fostering a trustworthy marketplace."
        },
        "5": {
          "title": "5. Prohibited Content and Activities",
          "content": "To maintain a safe and lawful environment on BIZI, users are strictly prohibited from engaging in the following:• Posting or Selling Illegal Items: This includes any item that is unlawful to sell or possess under local, state, national, or international laws. Examples include, but are not limited to:• Drugs: The sale or promotion of controlled substances, illegal drugs, or drug paraphernalia.• Weapons, firearms, or explosives.• Counterfeit goods or unauthorized replicas.• Stolen property.• Items that infringe on intellectual property rights (e.g., pirated software, bootlegged media).• Harmful or Offensive Content: Content that promotes hate speech, violence, abuse, harassment, or any form of discrimination will not be tolerated.• Sexually Explicit Content: Any form of pornographic, sexually explicit, or obscene material is strictly prohibited, including but not limited to:• Adult services or escort listings.• Sexually explicit images or videos.• Items or services promoting sexual exploitation or trafficking.• Dangerous Goods or Services: Listings that promote dangerous activities or illegal services (e.g., hacking services, human trafficking, illegal gambling) are strictly forbidden.• Misleading or Fraudulent Listings: Any false information or misrepresentation of products or services is prohibited.BIZI reserves the right to remove any listings or content that violate these policies. Violations may result in account suspension or termination and legal action as necessary."
        },
        "6": {
          "title": "6. Transactions and Payment",
          "content": "BIZI is a platform that connects users to buy and sell items. We do not process payments or facilitate financial transactions between users. All pricing and payment arrangements must be directly agreed upon between users. Users are solely responsible for their transactions and ensuring compliance with applicable laws and regulations."
        },
        "7": {
          "title": "7. Transactions and Disputes",
          "content": "While we facilitate interactions between buyers and sellers, we do not take part in the actual transactions and are not liable for the quality, legality, or safety of the items listed. Any disputes arising between users must be resolved directly between those parties."
        },
        "8": {
          "title": "8. Fees and Payments",
          "content": "Certain features of our platform may incur fees, which will be clearly outlined at the time of transaction. By using these services, you agree to pay any applicable fees. Please note that all fees are non-refundable unless required by law."
        },
        "9": {
          "title": "9. User-Generated Content",
          "content": "Users may post content such as product descriptions, reviews, and messages. When contributing content, you agree that it:• Will not violate any laws or regulations.• Will not be offensive, defamatory, or harmful to others.• Does not infringe on the intellectual property rights of others.We reserve the right to remove any content that violates these terms or is deemed inappropriate at our discretion."
        },
        "10": {
          "title": "10. Intellectual Property Rights",
          "content": "All content on BIZI, including logos, graphics, and text, is the intellectual property of BIZI or our licensors. You may not use, modify, or distribute any of our content without prior written consent. Unauthorized use may result in legal action."
        },
        "11": {
          "title": "11. Termination of Use",
          "content": "We reserve the right to suspend or terminate your account at any time, with or without cause. This includes, but is not limited to, violations of these Terms of Use or suspicious activity related to fraud. In cases of termination, we are under no obligation to maintain or provide access to your account data."
        },
        "12": {
          "title": "12. Limitation of Liability",
          "content": "BIZI is provided “as is” without any warranties, express or implied. We are not liable for any damages, losses, or disruptions that may arise from your use of our platform, including but not limited to:• Loss of profits or business opportunities.• Data loss or corruption.• Inability to access our platform due to technical issues."
        },
        "13": {
          "title": "13. Changes to Terms",
          "content": "We reserve the right to modify these Terms of Use at any time. Any changes will be communicated via our platform and will take effect immediately. Continued use of BIZI following any updates signifies your acceptance of the revised terms."
        },
        "14": {
          "title": "14. Governing Law",
          "content": "These Terms of Use are governed by and construed in accordance with the laws of Illinois. Any disputes arising from these terms will be subject to the exclusive jurisdiction of the courts in Mount Prospect, IL."
        },
        "15": {
          "title": "15. Contact Us",
          "content": "If you have any questions or concerns regarding these Terms of Use, please contact our support team at {email} or visit us at: BIZI 1699 Wall Street 108 Mount Prospect, IL 60056"
        }
      }
    }
        

}
